import { Apps32Filled } from '@fluentui/react-icons';
import { useI18nTranslation } from '@idmc-ms-fabric/common';
import { useFabricContext } from '@idmc-ms-fabric/integration';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useIDQALoggerContext } from '../../context/business/IDQAlogger/IDQALoggerContext';
import InfaLoginContext from '../../context/business/InfaLogin/InfaLoginContext';
import AppRegistrationContext from '../../context/business/Registration/AppRegistrationContext';
import i18nKeys from '../../i18n/i18nKeys';
import { API_STATUS, ApiResponseType } from '../../utils/common-types';
import ErrorScreen from '../core/error/ErrorScreen';
import ProgressScreen from '../core/progress/ProgressScreen';
import InitializeServices from './InitializeServices';
import InitializePendoAnalytics from './pendo/InitializePendoAnalytics';
type PageParams = { assetId?: string; workspaceObjectId?: string };
const Page: FC = ({ children }) => {
	const params = useParams<PageParams>();
	const { extensionClient } = useFabricContext();
	const { logger } = useIDQALoggerContext();
	const { t } = useI18nTranslation();
	const [workspaceId, setWorkspaceId] = useState<ApiResponseType<string>>({ status: API_STATUS.LOADING });
	const init = async () => {
		try {
			if (params.workspaceObjectId) {
				setWorkspaceId({
					status: API_STATUS.SUCCESS,
					details: params.workspaceObjectId,
				});
			} else if (params.assetId) {
				const aritactDetails = await extensionClient.itemCrud.getItem({ objectId: params.assetId });
				logger.info('getting artifact details successfull');
				setWorkspaceId({
					status: API_STATUS.SUCCESS,
					details: aritactDetails.folderObjectId,
				});
			} else {
				throw 'Error while resolving workspace details';
			}
		} catch (error) {
			logger.error('Error while getting Artifact details', { error });
			setWorkspaceId({
				status: API_STATUS.FAILURE,
				errorMsg: 'Error',
			});
		}
	};

	useEffect(() => {
		init();
	}, [params]);

	return workspaceId.status === API_STATUS.LOADING ? (
		<ProgressScreen icon={<Apps32Filled />} message={t(i18nKeys.main.pageLoading)} />
	) : workspaceId.status === API_STATUS.FAILURE ? (
		<ErrorScreen message={t(i18nKeys.main.pageFailure)} />
	) : (
		<AppRegistrationContext workspaceId={workspaceId.details}>
			<InfaLoginContext workspaceId={workspaceId.details}>
				<InitializeServices>
					<InitializePendoAnalytics>{children}</InitializePendoAnalytics>
				</InitializeServices>
			</InfaLoginContext>
		</AppRegistrationContext>
	);
};

export default Page;
